var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-agent-card-wrap" }, [
    _c("div", { staticClass: "go-widget-card featured" }, [
      _c("div", { staticClass: "go-widget-header" }, [
        _c("div", { staticClass: "go-elements" }, [
          _c("div", { staticClass: "go-widget-title" }, [
            _vm._v(_vm._s(_vm.$t("briefing.label.featuredAgents"))),
          ]),
        ]),
        _vm._v(" "),
        _vm.resourceItems.length > 2
          ? _c("div", { staticClass: "go-slide-footer" }, [
              _c("div", {
                staticClass:
                  "swiper-button-prev go-slide-nav go-slide-nav-prev",
                attrs: { id: "feat-pre" },
              }),
              _vm._v(" "),
              _c("div", {
                staticClass:
                  "swiper-pagination go-slide-pagination swiper-pagination-num",
                attrs: { id: "pag-num" },
              }),
              _vm._v(" "),
              _c("div", {
                staticClass:
                  "swiper-button-next go-slide-nav go-slide-nav-next",
                attrs: { id: "feat-next" },
              }),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "swiper",
              rawName: "v-swiper:companySwiper",
              value: _vm.swiperOptions,
              expression: "swiperOptions",
              arg: "companySwiper",
            },
          ],
          staticClass: "go-list-wrap swiper goSwiperCard",
        },
        [
          _c(
            "div",
            { staticClass: "swiper-wrapper" },
            _vm._l(_vm.resourceItems, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "go-list-item swiper-slide",
                  attrs: { "data-template": "card" },
                },
                [
                  _c("company-card-v2", {
                    key:
                      (item._id && item._id.concat("_" + index)) ||
                      (item.requestId && item.requestId.concat("_" + index)) ||
                      new Date()
                        .getTime()
                        .toString()
                        .concat("_" + index),
                    attrs: { "form-model": item },
                    on: {
                      "view-detail": function ($event) {
                        return _vm.viewDetail(item)
                      },
                      "view-detail-report": _vm.viewDetail,
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
      _vm._v(" "),
      _vm.resourceItems.length > 3
        ? _c("div", {
            staticClass: "swiper-button-prev",
            staticStyle: { "background-size": "88px 44px" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.resourceItems.length > 3
        ? _c("div", {
            staticClass: "swiper-button-next",
            staticStyle: { "background-size": "88px 44px" },
          })
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }